/** Derive a display name from the Cognito email (e.g. alex@oceany.ai → Alex). */
export function displayNameFromEmail(email: string | null | undefined): string {
  if (!email) return "Utente";
  const local = email.split("@")[0] ?? email;
  const first = local.split(/[._-]/)[0] ?? local;
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}

/** Initials for avatar (max 2 chars). */
export function initialsFromEmail(email: string | null | undefined): string {
  const name = displayNameFromEmail(email);
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}
